import { FC, ReactNode, useMemo } from 'react'
import { PermissionString } from './types'
import { usePermissions } from './usePermissions'
import { NotAuthorizedScreen } from './NotAuthorizedScreen'

interface ProtectedRouteProps {
  permission: PermissionString | PermissionString[]
  children: ReactNode
  unauthorizedComponent?: ReactNode
  needsEveryPermission?: boolean
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({
  permission,
  children,
  unauthorizedComponent,
  needsEveryPermission = false
}) => {
  const { can } = usePermissions()

  const hasPermission = useMemo(() => {
    if (Array.isArray(permission)) {
      if (needsEveryPermission) {
        return permission.every(p => can(p))
      }
      return permission.some(p => can(p))
    }

    return can(permission)
  }, [permission, needsEveryPermission, can])

  if (hasPermission) {
    return <>{children}</>
  }

  if (unauthorizedComponent) {
    return <>{unauthorizedComponent}</>
  }

  return <NotAuthorizedScreen />
}
